<template>
    <div>
        <div class="clearfix mt10 mb10">
            <div class="fl">
                <el-checkbox class="ml15" v-model="selected" @change="changeSelected">来源</el-checkbox>
            </div>
            <div class="fr">
                <div class="search-container primary">
                    <div class="form-box">
                        <input class="input-field" v-model="inqryTitle" placeholder="询价名称"/>
                        <button class="search-btn" @click="getPriceReplyVoucherList()"><i class="icon iconfont icon-search"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <div class="column-layout">
            <div class="table-layout">
                <el-table :height="500+'px'" ref="multipleTable" :data="priceReplyList" border tooltip-effect="dark" style="width: 100%" @current-change="handleCurrentChange">
                    <el-table-column width="55" v-if="showSelect">
                        <template slot-scope="rows">
                            <div class="copy-radio" :class="{'circle' : checlPriceReplyVoucher!= null && checlPriceReplyVoucher.id == rows.row.id}">
                                <div class="circle-dot"></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="inqryVoucherNo" label="询价单号" align="center" width="183">
                        <template slot-scope="rows">
                            <a class="swb-btn-link" @click.stop="toPriceInqryVoucherList(rows.row.inqryVoucherNo)">{{rows.row.inqryVoucherNo}}</a>
                        </template>
                    </el-table-column>
                    <el-table-column prop="inqryTitle" label="询价单名称" align="left" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" width="150" prop="contactName" label="联系人"></el-table-column>
                    <el-table-column align="left" width="120" prop="contactTel" label="联系电话"></el-table-column>
                    <el-table-column align="right" label="报价金额（元）" width="120" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span>{{parseFloat(rows.row.replyAmount).toFixed(2) || 0}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="replyTime" label="报价时间" width="180" show-overflow-tooltip></el-table-column>
                </el-table>
            </div>
            <div class="block pagination-layout">
                <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import priceApi from '../../api/price'

    export default{
        name: 'swb-price-inpry-for-select',
        desc: '选择-报价信息（忍受着）',
        props: {
            rowId: {
                type: Number,
                default: null
            },
            showSelect: {
                type: Boolean,
                default: false
            },
            toPriceInqryVoucher: {
                type: Function
            },
            type: {
                type: String
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data: function () {
            return {
                //
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                priceReplyList: [],
                inqryTitle: null,
                checlPriceReplyVoucher: {},
                priceInqryFlag: {},

                selected: false
            }
        },
        created: function () {
            //保持pageSize的一致性
            this.pageSize = this.pageSizes.first();
            //
            let self = this;
            if(self.rowId != null && self.rowId != '') {
                self.checlPriceReplyVoucher.id = self.rowId;
                self.selected = true;
            }

            self.priceInqryFlag = getEnumInfoWith('bizSrcFlag', 'name', 'PriceInqry');
            //
            self.getPriceReplyVoucherList();
        },
        methods: {
            changeSelected() {
                this.getPriceReplyVoucherList();
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getPriceReplyVoucherList();
            },
            getPriceReplyVoucherList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let filterItems = Utils.merge({}, self.filter);
                if(self.inqryTitle != null) {
                    filterItems.inqryTitle = self.inqryTitle;
                }
                if(self.type == "goods") {
                    filterItems.goodsFlag = true;
                } else {
                    filterItems.servcFlag = true;
                }
                filterItems.adopted = true;
                if(self.rowId != null && self.rowId != '' && self.selected) {
                    filterItems.id = self.rowId;
                } else if(self.selected) {
                    self.priceReplyList = [];
                    return false;
                }
                postData.filterItems = filterItems;
                let lastMsgBoxDlg = MsgBox.loading();
                priceApi.getPriceReplyVoucherList(postData, function (result) {
                    lastMsgBoxDlg.close();
                    if(result.type == 'info') {
                        let rowId = self.rowId;
                        let itemList = result.data.rows;
                        if(itemList != null && itemList.length > 0) {
                            for(var i = 0; i < itemList.length; i++) {
                                let item = itemList[i];
                                if(rowId != null && rowId == item.id) {
                                    self.checlPriceReplyVoucher = Utils.merge({}, item);
                                }
                            }
                        }
                        self.priceReplyList = itemList;
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleCurrentChange: function (val) {
                this.checlPriceReplyVoucher = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let returnInfo = null;
                let priceReplyVoucher = self.checlPriceReplyVoucher;
                if(priceReplyVoucher.id != null) {
                    returnInfo = {};
                    returnInfo.srcId = priceReplyVoucher.inqryVoucherId;
                    returnInfo.srcWinId = priceReplyVoucher.id;
                    returnInfo.srcFlag = self.priceInqryFlag.value;
                }
                return returnInfo;
            },
            toPriceInqryVoucherList: function (no) {
                this.toPriceInqryVoucher.call(parent, no);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/priceInpry/PriceInpryForSelect.vue